import { useTranslation } from "next-i18next";

import PaymentTitle from "../PaymentTitle";

import styles from "./PaymentHeader.module.scss";

const NUMBER_OF_DOTS = 4;

const PaymentHeader = () => {
  const { t } = useTranslation("translations");

  return (
    <div className={styles.header}>
      <div className={styles.dots}>
        {Array.from({ length: NUMBER_OF_DOTS }, (_, index) => (
          <div key={index} className={styles.dot}></div>
        ))}
      </div>

      <PaymentTitle>{t("web_payment_header")}</PaymentTitle>
    </div>
  );
};

export default PaymentHeader;
